module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagei"
    }
  }, [_c('div', {
    staticClass: "chapterHead1"
  }, [_c('h2', {
    staticClass: "chapterTitle1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“My lord, there’s been an error,” Triona began.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText1"
  }, [_vm._v("It was too late. The coach was moving. Triona glared at MacLean’s dark, shadowy form. “My lord, I am not who you think I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What?” Amusement and disbelief colored his voice. “Then you are not Miss Hurst.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No. I mean, yes. I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" Miss Hurst, but "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" the Miss Hurst you think me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Even in the gloom, she could make out the flash of his teeth as he smiled. “I see,” he said politely. “You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" Miss Hurst, but then you are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(". Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I am Miss "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Caitriona")]), _vm._v(" Hurst. Caitlyn is my sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Of course she is.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Triona relaxed a bit. Thank goodness he was a man of reason! “This has been a horrible mistake. Oh dear, this is so indelicate and Caitlyn would—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He reached across the coach, his hands large and warm, closing about her waist as he lifted her and placed her in his lap. He grinned, his handsome face within inches of her own as he said in a low voice, his breath warm on her cheek, his sensual cologne tickling her nose. “Since I caught the little bird, then she is mine to enjoy. But first, let us agree to dispense with story time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“My lord, you don’t understand! I’m not Ca—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was then he committed an even more unthinkable act than holding her in his large, warm lap, as scandalous as it was. In the semidarkness of a luxurious coach as it dashed madly through a snowy night, MacLean bent his head and kissed her.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterByline"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Turn the page for rave reviews of Karen Hawkins’s romantic storytelling…")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-265835d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781439164341_fm01.vue
// module id = 66
// module chunks = 0